module.exports = __webpack_public_path__ + "img/Konachan.com-293687.6e367f62.jpg";